import * as React from 'react';
import { GroupCardListItem } from '@fieldnation/platform-components';
import classNames from 'classnames';
import TimelinessDetails from './ReliabilityScore/TimelinessScore/Modal/TimelinessDetails';
import { IReliabilityScore, ScoreType } from './types.d';
import trackAmplitudeEvent, { VIEWED_RELIABILITY_DETAILS } from '../ProviderSnapshot/amplitude';
import css from './Reliability.scss';

interface Props {
  providerId: number;
  reliabilityScore: IReliabilityScore;
}

export default function TimelinessRate(props: Props): JSX.Element {
  const { providerId, reliabilityScore } = props;
  const [openDetails, setOpenDetails] = React.useState(false);
  const timelinessScore = reliabilityScore?.[ScoreType.Timeliness] ?? {};
  const scoreValue = timelinessScore?.score >= 0 && timelinessScore?.count > 4 ? (
    `${timelinessScore?.score}%`
  ) : (
    <span className={classNames('text-muted', css['reliability-sub-text'])}>not enough data</span>
  );

  return (
    <>
      <div className="u-padding-bottom--md">
        <div className={css['reliability-container']}>
          <GroupCardListItem
            hideExpander
            dottedLine
            middleContent=""
            label={(
              <>
                <span>Timeliness Score</span>
                {timelinessScore?.target > 0 && (
                  <span className="text-muted">
                    {' '}
                    &nbsp;
                    {`(≥ ${timelinessScore.target}% target)`}
                    {' '}
                    &nbsp;
                  </span>
                )}
              </>
            )}
            data={<span className={css['text-semi-bold']}>{scoreValue}</span>}
            type="default"
            border="none"
          />
        </div>
        {timelinessScore?.details?.totalTimeLog > 0 && timelinessScore?.count > 4 && (
          <>
            <div className={classNames('text-muted', css['reliability-sub-text'])}>
              {timelinessScore?.details?.totalOnTime || '0'}
              {' '}
              of last
              {' '}
              {timelinessScore?.details?.totalTimeLog || ''}
              {' '}
              “Hard-Start” work orders checked in on-time
            </div>
            <div>
              <button
                className={css['show-reliability-details']}
                type="button"
                onClick={() => {
                  setOpenDetails(true);
                  const match = window.location.pathname.match(/workorders\/(\d)+\/providers/g);
                  trackAmplitudeEvent({
                    category: VIEWED_RELIABILITY_DETAILS,
                    ampProps: {
                      Source: match?.length ? 'Provider Drawer' : 'Profile',
                      Type: 'Timeliness Score',
                      Score: timelinessScore?.score ?? 0,
                    },
                  });
                }}
              >
                <span className={css['reliability-sub-text']}>
                  See check-in details
                </span>
              </button>
            </div>
          </>
        )}
      </div>
      <TimelinessDetails
        isOpen={openDetails}
        onClose={() => setOpenDetails(false)}
        providerId={providerId}
        reliabilityScore={reliabilityScore}
      />
    </>
  );
}
